<template>
    <div class="demand-publish">
        <div class="publish-form-wrap">
            <div class="title">我要发布</div>
            <div class="form">
                <div class="my-form">
                    <el-form autoComplete="on" :model="form" v-loading="loading" :rules="formRules"
                        element-loading-text="给我一点时间" label-position="right" ref="form" label-width="150px"
                        label-suffix="：">

                        <el-form-item label="发布板块" prop="model">
                            <div class="plate-wrap">
                                <div class="item" :class="{ active: form.model == 'group' }"
                                    @click="form.model = 'group'">课题组研究方向</div>
                                <div class="item" :class="{ active: form.model == 'demand' }"
                                    @click="form.model = 'demand'">企业需求</div>
                            </div>
                        </el-form-item>
                        <el-form-item label="发布标题" prop="title">
                            <el-input type="text" style="width:450px" v-model="form.title" placeholder="请输入发布标题">
                            </el-input>
                        </el-form-item>
                        <el-form-item label="封面图" prop="cover">
                            <form-image v-model="form.cover" :config="{ name: '请上传封面图' }"></form-image>
                        </el-form-item>
                        <el-form-item label="发布内容" prop="content">
                            <el-input style="width:550px" type="textarea" :autosize="{ minRows: 5, maxRows: 10 }"
                                v-model="form.content" placeholder="请输入发布内容">
                            </el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="submit" class="my-btn" :loading="loading" @click="handleSubmit">
                                提交审核
                            </el-button>
                        </el-form-item>
                    </el-form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import { saveArticle } from "@/api/article";
import FormImage from '@/components/form/image' //单图上传

export default {
    name: "AcademicPublish",
    components: {
        FormImage
    },
    props: {},
    data() {
        return {
            loading: false,
            form: {
                model: 'group',
                title: null,
                cover: '',
                content: null,
            },
            formRules: {
                title: [
                    { required: true, message: "请输入标题", trigger: "blur" },
                ],
                content: [
                    { required: true, message: "请输入内容", trigger: "blur" },
                ],
                cover: [
                    { required: true, message: "请上传封面图", trigger: "blur" },
                ],

            },
        }
    },
    filters: {

    },
    computed: {

    },
    created() {
        this.form.order_id = this.$route.query.order_id || 0
        this.form.type = this.$route.query.type || 0
    },
    mounted() {

    },
    methods: {
        getPreview() {
            getPreview(this.form).then(res => {
                this.form.price = res.data.price;
                this.form.balance = res.data.balance;
                this.form.subject = res.data.subject
            }).catch((err) => {

            });
        },
        resetPayPassword() {
            this.showResetPayPasswordForm = true;
        },
        // 提交信息
        handleSubmit() {
            // 验证form表单
            this.$refs.form.validate((valid) => {
                if (valid) {
                    this.loading = true;
                    const _form = JSON.parse(JSON.stringify(this.form))
                    saveArticle(_form).then((response) => {
                        this.loading = false;
                        // 弹出操作提示
                        this.$message({
                            type: 'success',
                            message: '提交成功!'
                        });
                        this.getIdentityPreview();
                    }).catch(() => {
                        this.loading = false;
                    });
                }
            });
        },

    }
};
</script>
<style lang="scss" scoped>
.demand-publish {
    width: 100%;
    background-color: #F4F8F9;
    padding: 22px 0 166px 0;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    flex-direction: column;

    .publish-form-wrap {
        width: 940px;
        background: #FFFFFF;
        box-shadow: 0px 1px 5px 1px rgba(0, 0, 0, 0.0196);
        box-sizing: border-box;

        .title {
            width: 100%;
            padding: 20px 43px;
            font-size: 20px;
            font-weight: bold;
            color: #222222;
            border-bottom: 1px solid #a7acb228;
            box-sizing: border-box
        }

        .form {
            width: 100%;
            padding: 32px 77px;

            .plate-wrap {
                display: flex;
                align-items: center;
                column-gap: 20px;

                .item {
                    width: 130px;
                    height: 40px;
                    background: #FFFFFF;
                    border-radius: 4px;
                    font-size: 14px;
                    font-weight: 300;
                    color: #222222;
                    border: 1px solid #222222;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    cursor: pointer;
                }

                .active {
                    background: #00B4E8;
                    color: #FFFFFF;
                    border: none;
                }
            }
        }
    }
}
</style>